import React, { useContext, useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { useRange } from 'react-instantsearch';

import DatePicker from '@components/molecules/date-picker/datePicker';
import Copy from '@components/atoms/copy/copy';
import { Context } from '../../../context/provider';

const FilterDates = () => {
  const t = useTranslations();
  const { filter, setFromDate, setToDate } = useContext(Context);

  const [error, setError] = useState(null);
  const { refine, start, range } = useRange({
    operator: 'or',
    attribute: 'post_date_timestamp'
  });

  const min = Math.max(range.min, Number.isFinite(start[0]) ? start[0] : range.min);
  const max = Math.min(range.max, Number.isFinite(start[1]) ? start[1] : range.max);

  const refineDates = () => {
    if (filter.fromDate && filter.toDate && filter.fromDate > filter.toDate) {
      return setError(t('archive.dateError'));
    }

    if (!filter.fromDate && !filter.toDate) {
      refine([min, max]);
      return setError(null);
    }

    const from = new Date(filter.fromDate);
    const to = new Date(filter.toDate);

    if (from?.getFullYear() > 1000 && to?.getFullYear() > 1000) {
      // INFO: Typesense expects Unix timestamps for expiry_date in Seconds since the Unix Epoch
      const unixTimestampFrom = Math.round(from.getTime() / 1000);
      const unixTimestampTo = Math.round(to.getTime() / 1000);

      refine([
        unixTimestampFrom < min ? min : unixTimestampFrom,
        unixTimestampTo > max ? max : unixTimestampTo
      ]);
      return setError(null);
    }
    return setError(null);
  };

  useEffect(() => {
    refineDates();
  }, [filter.fromDate, filter.toDate]);

  const getDateFromUnix = unix => (unix ? new Date(unix * 1000) : undefined);

  return (
    <>
      <Copy className="filter-dates__label" uppercase>
        {t('archive.dateLabel')}
      </Copy>
      <div className={`time-period ${error ? 'time-period--error' : ''}`}>
        <DatePicker
          minDate={getDateFromUnix(min)}
          maxDate={new Date()}
          placeholder={t('archive.dateFrom')}
          value={filter.fromDate}
          onChange={setFromDate}
          error={error}
        />
        <DatePicker
          minDate={getDateFromUnix(min)}
          maxDate={new Date()}
          placeholder={t('archive.dateTo')}
          value={filter.toDate}
          onChange={setToDate}
          error={error}
        />
      </div>
      {error && <Copy className="filter-dates__warning">{error}</Copy>}
    </>
  );
};

export default FilterDates;
